import { context } from "@core-ts/Contexts/Context"
import { Instance } from "@core-ts/Contexts/Instance"
import { StandardError } from "@core-ts/StandardError"


export class FrontendInstance extends Instance {

    reportSuccessHandler: ((message: string) => void) | undefined

    reportSuccess(message: string): void {
        if(this.reportSuccessHandler)
            this.reportSuccessHandler(message)
        else
            console.log(message)
    }
    
    setSuccessHandler(handler: ((message: string) => void)): void {
        this.reportSuccessHandler = handler
    }

    reportErrorHandler: ((message: string) => void) | undefined

    reportError(message: string): void {
        if(this.reportErrorHandler)
            this.reportErrorHandler(message)
        else
            alert("Error: " + message)
    }

    setErrorHandler(handler: ((message: string) => void)): void {
        this.reportErrorHandler = handler
    }
}

export function getFrontendInstance(): FrontendInstance {
    if(context.instance instanceof FrontendInstance) {

        return context.instance
    }
    
    throw new StandardError("Tried to access frontend instance, but it is not a frontend instance")
}

/*export function setFrontendApplication(p_application: FrontendInstance) {
    setApplication(p_application)
    frontendApplication = p_application
}

export let frontendApplication: FrontendInstance
*/